import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DropdownMenu } from '@paypalcorp/pp-react';

class PhoneCountryCode extends React.Component {
  constructor(props) {
    super();
    const { defaultNumber: { countryCode } = {} } = props;
    this.state = {
      countryCode: countryCode,
      phoneTypeErrorMessage: '',
      showIsRequiredError: false,
      selectedItemIdx: -1,
    };
  }

  handleChange = (index) => {
    let value =
      index >= 0
        ? this.props.supportedCountries[index].phoneCode
        : this.state.countryCode;
    this.setState({ countryCode: value, selectedItemIdx: index });
    this.props.changeCountryCode(value);
  };

  render() {
    const { errorMessage, label, supportedCountries } = this.props;
    let { countryCodeErrorMessage } = this.state;

    return (
      <div
        className={classNames({
          'vx_has-error-with-message': errorMessage,
          'ppvx_field--error': errorMessage,
        })}
        style={{ margin: '0 0 10px 0', position: 'relative' }}
      >
        <div style={{ position: 'relative' }}>
          <DropdownMenu
            type="button"
            label={label}
            options={supportedCountries.map((item) => ({
              primaryText: `${item.phoneCode} (${item.countryCode})`,
            }))}
            onSelection={this.handleChange}
            errorText={errorMessage || countryCodeErrorMessage}
            selectedItemIndex={this.state.selectedItemIdx}
          />
        </div>
      </div>
    );
  }
}

PhoneCountryCode.propTypes = {
  changeCountryCode: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  guestLabels: PropTypes.object,
  label: PropTypes.string,
  supportedCountries: PropTypes.array,
};

export default PhoneCountryCode;
